import React from 'react';
import { Col, DatePicker, Form, Input, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const InfoSection = ({ disabled, shoppingCenters }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Info')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Titolo')} name='title'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Categorie')} name='category'>
          <Select placeholder={t('Categorie')}>
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            <Select.OptGroup label={t('Classifiche')}>
              <Select.Option value='weekly'>{t('Settimanali')}</Select.Option>
              <Select.Option value='monthly'>{t('Mensili')}</Select.Option>
            </Select.OptGroup>
            <Select.Option value='circulars'>{t('Circolari')}</Select.Option>
            <Select.Option value='manuals'>
              {t('Manuali village')}
            </Select.Option>
            <Select.Option value='admin_releases'>
              {t('Comunicati amministrativi')}
            </Select.Option>
          </Select>
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item label={t('Data pubblicazione')} name='date'>
          <DatePicker
            format={'DD MMMM YYYY'}
            style={{ width: '100%' }}
            disabled={disabled}
          />
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item label={t('Outlet Village')} name='shopping_center_id'>
          <Select placeholder={t('Outlet Village')}>
            <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
            {shoppingCenters &&
              shoppingCenters.map((village) => (
                <Select.Option key={village.id} value={village.id}>
                  {village.title}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
